import { memo, useLayoutEffect } from 'react';
import { startsWith } from 'lodash';
import { useLocation } from 'react-router-dom';

export interface DocumentTitleProps {
  readonly title: string;
  readonly description?: string;
  readonly image?: string;
  readonly noIndex?: 'all' | 'no-index';
}

export const DocumentTitle = memo<DocumentTitleProps>(({
  title = 'Book More Gigs and Get Paid Faster',
  description = 'Find venues, manage gigs, and sell tickets in one platform. Sign up free!',
  image = 'https://sidedooraccess.com/icons/logo_full_1024.png',
  noIndex = process.env.NODE_ENV === 'production' ? 'all' : 'noindex',
}) => {
  let imageUrl = image;
  const location = useLocation();

  if (startsWith(imageUrl, '/')) {
    imageUrl = `${process.env.SITE_BASE_URL}${imageUrl}`;
  }

  useLayoutEffect(() => {
    document.title = `${title} — Side Door`;

    document.querySelectorAll('meta').forEach((item) => {
      if (item.name) {
        switch (item.name) {
          case 'description': {
            item.setAttribute('content', description);
            break;
          }
          case 'robots': {
            item.setAttribute('content', noIndex);
            break;
          }
          default:
            break;
        }
      } else if (item.getAttribute('property')) {
        switch (item.getAttribute('property')) {
          case 'og:title': {
            item.setAttribute('content', title);
            break;
          }
          case 'og:image': {
            item.setAttribute('content', imageUrl);
            break;
          }
          case 'og:description': {
            item.setAttribute('content', description);
            break;
          }
          default:
            break;
        }
      }
    });

    document.querySelectorAll('link').forEach((item) => {
      if (item.getAttribute('rel') === 'canonical') {
        item.setAttribute('href', `https://sidedooraccess.com${location.pathname}`);
      }
    });
  });

  return null;
});
